import React from "react";
import { Meeting } from "../types/meetings";
import { MeetingCard } from "./MeetingCard";
import { Card } from "./ui/card";
import { FileX } from "lucide-react";

interface AllMeetingsListProps {
  meetings: (Meeting & { summary: string; action_items_count: number; })[];
  isLoading: boolean;
  error?: Error;
}

export function AllMeetingsList({ meetings, isLoading, error }: AllMeetingsListProps) {
  if (isLoading) {
    return (
      <div className="space-y-4 w-full">
        {[1, 2, 3].map((n) => (
          <Card key={n} className="h-32 animate-pulse bg-neutral-100 w-full" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <Card className="p-6 w-full">
        <div className="text-center space-y-4">
          <FileX className="mx-auto h-12 w-12 text-red-500" />
          <div className="space-y-2">
            <h3 className="font-semibold">Error Loading Meetings</h3>
            <p className="text-sm text-neutral-500">
              {error.message || "An unexpected error occurred. Please try again later."}
            </p>
          </div>
        </div>
      </Card>
    );
  }

  if (!meetings.length) {
    return (
      <Card className="p-6">
        <div className="text-center space-y-2">
          <h3 className="font-semibold">No Meetings Found</h3>
          <p className="text-sm text-neutral-500">
            Start by recording a new meeting or uploading an existing one.
          </p>
        </div>
      </Card>
    );
  }

  return (
    <div className="grid gap-2 w-full">
      {meetings.map((meeting) => (
        <MeetingCard key={meeting.id} meeting={meeting} />
      ))}
    </div>
  );
}